<template>
  <div style="padding: 20px 30px 0 30px;overflow: auto;height: 60vh">
    <el-table
      :data="tableData"
      border
      height="calc(52vh - 30px)"
      class="table">
      <el-table-column
        align="center"
        label=""
        type="index">
      </el-table-column>
      <el-table-column
        prop="startTime"
        align="center"
        label="开始时间">
      </el-table-column>
      <el-table-column
        prop="endTime"
        align="center"
        label="结束时间">
        <template slot-scope="scope">
          {{ scope.row.endTime? scope.row.endTime : '-' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        align="center"
        label="联动结果">
        <template slot-scope="scope">
          {{ scope.row.endTime? '成功' : '执行中' }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作">
        <template slot-scope="scope">
          <span class="pointer text-blue" @touchstart="openDialog(scope.row)" @click="openDialog(scope.row)">详情</span>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="margin-top: 25px;text-align: center;" v-if="dataTotal>pageForm.size">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="pageForm.currentPage"
        :page-size="pageForm.size"
        :total="dataTotal">
      </el-pagination>
    </el-row>


    <dialog-component
      :dialog-title="dialogTitle"
      :closeClick="false"
      :dialogVisible.sync="dialogVisible"
      :width="width"
      @dialogClose="(data) => this.dialogVisible = data">
      <div slot="content" style="height: 70vh">
        <linkage-logs ref="actionLogs" :item="this.action" :isComplex="true"></linkage-logs>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import DialogComponent from "@/components/DialogComponent";
import LinkageLogs from "@/views/basic_operations/strategy/linkage/LinkageLogs";
import {getPage} from "@/network/activiti";

export default {
  name: "LinkageLogList",
  components: {LinkageLogs, DialogComponent},
  props: ["item"],
  data() {
    return {
      tableData: [{}],
      dataTotal: 0,
      dialogVisible: false,
      dialogTitle: '记录详情',
      width: '75vw,',
      action: {},
      pageForm: {
        id: '',
        //当前页数
        currentPage: 1,
        // 每页数
        size: 10,
      },
    }
  },
  watch: {
    item() {
      this.dataTotal = 0;
      this.pageForm.currentPage = 1;
      this.getFinishedInstance();
    }
  },
  mounted() {
    this.dataTotal = 0;
    // 复杂策略 获取联动记录
    this.getFinishedInstance();
  },
  methods: {
    // 获取联动记录  分页
    getFinishedInstance() {
      this.tableData = [];
      if (!this.item) {
        return;
      }
      this.pageForm.id = this.item.deviceLinkageActiviti.procId;
      if (this.pageForm.id) {
        getPage(this.pageForm).then(res => {
          if (res.code === 0) {
            let bln = res.data == null;
            this.tableData =bln? []:res.data.record;
            this.dataTotal = bln ? 0 : res.data.countSize;
          }
        });
      }
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageForm.currentPage = val;
      this.pageForm.size = 10;
      this.getFinishedInstance();
    },
    // 显示详情
    openDialog(data) {
      this.action = data;
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>

</style>
